<template>
  <div class="createCollection">
      <el-button class="collected" @click="deleteFrontCollection" :loading="loading_icon">已收藏</el-button>
  </div>
</template>

<script>
export default {
    props:{
        cancel_obj:{
            type:Object
        }
    },
    data(){
        return{
            loading_icon:false
        }
    },
    created(){},
    computed:{
        // 个人信息
        info() {
            return this.$store.state.info;
        },
        // 登录弹框
        loginVisible() {
            return this.$store.state.isLoginDialog;
        }
    },
    methods:{
        // 取消收藏
        deleteFrontCollection(){
            // 未登录
            if(!this.$store.state.info){
                this.$store.dispatch("setIsLoginDialog", true);
                return;
            }
            this.loading_icon = true;
            this.api.deleteFrontCollection({code:this.cancel_obj.code},true)
            .then(res => {
                if(res.error.err_code != 0) return;
                this.$message({
                    message:'您已取消收藏！',
                    type:'info'
                })
                this.loading_icon = false;
                this.cancel_obj.isCollection = false;
            })
        },
        //监听个人信息
        needInfo(fn) {
            let watchAch = this.$watch("info", (val, oldVal) => {
                if (val) {
                this[fn]();
                watchAch(); //取消监听
                }
            });
        },
    },
}
</script>

<style lang="scss">
.createCollection{
    .el-button{
        width:188px;
        height:42px;
    }
    .collected{
        border: 1px solid #ff6d00;
        color: #ff6d00;
        background-color: #fff;
    }
}
</style>